<template>
  <div class="products-wrapper">
    <section class="products">
      <div
        v-for="(product, i) in products"
        :key="`product-${i}`"
        class="product"
      >
        <Icon :icon="product.icon" />
        <RichText :field="product.header" class="marked" />
        <RichImage :field="product.image" />
        <RichText :field="product.description" />
      </div>
    </section>
  </div>
</template>
<script>
import Icon from '@/components/Icon';

export default {
  components: {
    Icon
  },
  props: {
    products: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/base/colors';
@import '../scss/helpers/mixins';

.products {
  .icon {
    font-size: 2em;
    color: $primary;
  }

  .image {
    margin-bottom: 1em;
  }

  .product {
    padding-left: 20px;
    padding-right: 20px;

    border-bottom: 1px $grey-3 solid;
    margin-bottom: 30px;

    ::v-deep p {
      margin-bottom: 1em;
    }
  }
}

@include breakpoint(M) {
  .products-wrapper {
    border-bottom: 1px $grey-3 solid;
    margin-bottom: 50px;
  }

  .products {
    max-width: 1000px;
    margin: 0 auto;
    display: flex;

    .product {
      flex: 1;
      border-bottom: 0;
      margin-bottom: 50px;

      ::v-deep h2 {
        font-size: 1.7em;
        margin-bottom: 1em;
        min-height: 2.25em;
      }
    }
  }
}
</style>
